export default (state, action) => {
  let updatedState
  switch(action.type) {
    case 'DELETE':
      updatedState = { ...state }
      delete updatedState.worksheet_data[action.payload.sectionId][action.payload.id]
      return updatedState
    case 'ADD_NEW':
      updatedState = { ...state }
      updatedState.worksheet_data[action.payload.sectionId][action.payload.title] = action.payload.fields
      return updatedState
    case 'UPDATE_CARD_TITLE':
      const originalVal = state.worksheet_data[action.payload.sectionId][action.payload.id]
      updatedState = {...state}
      delete updatedState.worksheet_data[action.payload.sectionId][action.payload.id]
      updatedState.worksheet_data[action.payload.sectionId][action.payload.newCardTitle] = originalVal
      return updatedState
    case 'CALC_SECTION':
      updatedState = {
        ...state,
        worksheet_data: {
          ...state.worksheet_data,
          [action.payload.sectionId]: {
            ...state.worksheet_data[action.payload.sectionId],
            [action.payload.id]: {
              ...state.worksheet_data[action.payload.sectionId][action.payload.id],
              [action.payload.name]: action.payload.value,
            },
          }
        }
      }
      return updatedState
    case 'SET_VIEW':
      updatedState = {
        ...state,
        view: action.payload
      }
      return updatedState
    case 'SET_TITLE':
      updatedState = {
        ...state,
        title: action.payload,
      }
      return updatedState
    case 'SET_LOADING':
      updatedState = {
        ...state,
        loading: action.payload
      }
      return updatedState
    default:
      return state
  }
}